import script from "./Shell.vue?vue&type=script&setup=true&lang=js"
export * from "./Shell.vue?vue&type=script&setup=true&lang=js"

import "./Shell.vue?vue&type=style&index=0&id=76f7876e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f7876e"]])

export default __exports__